$(document).ready(function () {

    function price_to_button() {
    if ($(".form__quantity .quantity__input").length) {
      var currency = $(".main_product-temp .product-form__submit .btn_price_wrap" ).data("currency");
      // var price = parseFloat($(".main_product-temp .product-form__submit .btn_price_wrap span").data("variant-price")) * parseFloat($(".form__quantity .quantity__input").val());
      var up_price = $(".product-price-container .update-amount").text();
      var up_price = parseFloat(up_price.replace("$","")) * parseFloat($(".form__quantity .quantity__input").val());
      // price = price / 100;
      var main_price = currency + up_price.toFixed(2);
      $(".main_product-temp .product-form__submit .btn_price_wrap span").text( " - " + main_price);
      $(".product-add-to-cart-sticky .product-form .add_to_cart_holder .btn_price_wrap span").text(" - " + main_price);
    }
  }

  setInterval(function () {
    price_to_button();
  }, 100);


  
    if($('.product-sticky-cart').length){
    $(window).scroll(function(){
      var btn_pos = $('.main-product-section product-info product-form').offset().top;
      var footer_pos_top = $('footer').offset().top;
      var footer_pos_btm = footer_pos_top + $('footer').outerHeight();
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > btn_pos && viewportbottom < footer_pos_top){
        $('.product-sticky-cart').fadeIn(500);
      }else{
        $('.product-sticky-cart').fadeOut(500);
      }
    });
  }
  
});